
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report/storm",
      function () {
        return require("private-next-pages/report/storm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report/storm"])
      });
    }
  